import {Component, ViewChild} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {MembershipTypeEntityModel} from "../../membership-type-entity.model";
import {EditGridComponent} from "../../../../framework/entity/edit/edit-grid/edit-grid.component";
import {CustomObjectSearchPageComponent} from "../../../../custom-objects/custom-object/custom-object-search-page/custom-object-search-page.component";

@Component({
    selector: "wbo-membership-type-edit-custom-objects",
    templateUrl: "./membership-type-edit-custom-objects.component.html"
})
export class MembershipTypeEditCustomObjectsComponent {
    constructor(public model: MembershipTypeEntityModel, public editService: EditService) {
    }

}
